import React, { useEffect, useState } from "react";
import {
  Box,
  Dialog,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  useTheme,
  Checkbox,
} from "@material-ui/core";
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import Button from "../../components/CustomButtons/Button.js";
import Card from "../../components/Card/Card.js";
import CardHeader from "../../components/Card/CardHeader.js";
import CardBody from "../../components/Card/CardBody.js";
import axios from "axios";
import {
  baseUrl,
  GetAllLabsAPI,
  GetAllOrdersAPI,
  WhatsAppAPI,
} from "../../config/api";
import { Autocomplete } from "@material-ui/lab";
import _ from "lodash";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment";
import { htmlTemplateToDataString, dataURItoBlob } from "../../utils";
import { fxOrderTemplate } from "../../assets/html/readyOrderTemplate.js";

const styles = {
  formControl: {
    paddingBottom: "10px",
    margin: "27px 0 0 0",
    position: "relative",
    verticalAlign: "unset",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
};

const useStyles = makeStyles(styles);
const columns = [
  { id: "party", label: "Party" },
  { id: "code", label: "Order code" },
  { id: "productName", label: "Product" },
  { id: "power", label: "Power" },
  {
    id: "orderAmount",
    label: "Order Amount",
    format: (value) => {
      const numValue = Number(value);
      if (isNaN(numValue)) return value;
      return numValue.toLocaleString("en-IN", {
        maximumFractionDigits: 2,
        style: "currency",
        currency: "INR",
      });
    },
  },
];

export default function SendWhatsApp(props) {
  const classes = useStyles();
  const theme = useTheme();
  const userInfo = useSelector((state) => state.userReducer.userInfo);
  const authToken = useSelector((state) => state.userReducer.authToken);

  const orderStatus = "Pending"

  const { open, close, fetchData } = props;
  const [lab, setLab] = useState([]);
  const [selectedLab, setSelectedLab] = useState(null);
  const [orders, setOrders] = useState([]);
  const [orderLoaded, setOrderLoaded] = useState(false);
  const [whatsappSent, setWhatsappSent] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    if (open) {
      _getLabs();
    }
  }, [open]);

  async function _getLabs() {
    try {
      let res = await axios.get(GetAllLabsAPI(userInfo.entity));
      setLab(res.data);
    } catch (e) {
      console.error(e);
    }
  }

  async function _getOrders() {
    try {
      if (!selectedLab) {
        toast.error("Please select a lab first");
        return;
      }
      let res = await axios.get(
        GetAllOrdersAPI(userInfo.entity) + `&lab=${selectedLab.labName}` + `&orderStatus=${orderStatus}` + `&isWhatsAppSent=${false}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      setOrders(res.data.orders);
      setOrderLoaded(true);
      setWhatsappSent(false);
    } catch (err) {
      console.error(err);
    }
  }

  const createPdfForOrders = (orders, labName, datetime) => {
    const options = {
      orientation: "p",
      unit: "pt",
      format: [284, 433],
      putOnlyUsedFonts: true,
    };
    const htmlTemplate = fxOrderTemplate(orders, baseUrl);

    return new Promise((resolve, reject) => {
      try {
        htmlTemplateToDataString(htmlTemplate, options, (dataString) => {
          try {
            const blob = dataURItoBlob(dataString);
            // Generate filename using lab name and datetime
            const sanitizedLabName = labName.replace(/[^a-zA-Z0-9]/g, "_");
            const sanitizedDateTime = datetime.replace(/[^a-zA-Z0-9]/g, "_");
            const fileName = `${sanitizedLabName}_${sanitizedDateTime}.pdf`;
            resolve({
              fileName,
              blob,
            });
          } catch (conversionError) {
            reject(conversionError);
          }
        });
      } catch (err) {
        reject(err);
      }
    });
  };

  async function _postWhatsApp() {
    try {
      if (!selectedLab) {
        toast.error("Please select a lab first");
        return;
      }
      console.log(selectedLab, "selectedLab");
      const selectedOrders = orders.filter((order) =>
        selectedRows.includes(order._id)
      );

      if (!selectedOrders.length) {
        toast.error("Please select at least one order");
        return;
      }

      const contactNumber =
        selectedLab.whatsappNumber ||
        selectedLab.mobile;
      if (!contactNumber) {
        toast.error("No WhatsApp number found for this lab");
        return;
      }

      const template = "send_lab_prescription_orders";
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const today = moment().format("DD/MM/YYYY");
      const labName = selectedLab.labName || "Lab";
      const baseMessage = `New orders from ${labName} - ${moment().format("DD/MM/YYYY HH:mm")}`;

      // Generate PDF for all selected orders together
      const datetime = moment().format("YYYY-MM-DD_HH-mm-ss-SSS");
      const { blob, fileName } = await createPdfForOrders(selectedOrders, labName, datetime);

      // Create a Blob URL and open the PDF in a new tab/window (preview for user)
      const url = URL.createObjectURL(blob);
      window.open(url, "_blank");

      // Send the combined PDF + metadata to backend WhatsApp route
      const formData = new FormData();
      formData.append("to", contactNumber);
      formData.append("message", baseMessage);
      formData.append("template", template);
      formData.append("orders", JSON.stringify(selectedOrders.map((order) => order._id)));
      formData.append("lab", selectedLab._id);
      formData.append("entity", userInfo.entity);
      formData.append("recipientName", labName);
      formData.append("startDate", today);
      formData.append("endDate", today);
      formData.append("totalOrders", String(selectedOrders.length));
      formData.append("senderName", userInfo.name || "");
      formData.append("pdf", blob, fileName);

      const response = await axios.post(
        `${baseUrl}/send-whatsapp/orders`,
        formData,
        { headers }
      );

      if (!response.data?.success) {
        throw new Error(
          response.data.message || "Failed to send WhatsApp message"
        );
      }
      toast.success("WhatsApp message sent successfully!");
      setWhatsappSent(true);
      setSelectedRows([]);
      await _getOrders();
    } catch (error) {
      console.error("WhatsApp send error:", error);
      toast.error(error.message || "Failed to send WhatsApp message");
    }
  }

  // Helper function to format WhatsApp message
  function formatWhatsAppMessage(orders, lab) {
    let message = `New Orders for ${lab.labName}\n\n`;

    orders.forEach((order, index) => {
      message += `${index + 1}. Order #${order.code}\n`;
      message += `Product: ${order.orderDetail.productName}\n`;
      message += `Power:\n`;
      message += `R: ${order.orderDetail.rSph}${order.orderDetail.rCyl}/${order.orderDetail.rAxis}/${order.orderDetail.rAddition}\n`;
      message += `L: ${order.orderDetail.lSph}${order.orderDetail.lCyl}/${order.orderDetail.lAxis}/${order.orderDetail.lAddition}\n`;
      message += `Amount: ${order.price}\n\n`;
    });

    return message;
  }

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={close}
      aria-labelledby="responsive-dialog-title"
    >
      <GridContainer>
        <GridItem xs={12} sm={12}>
          <Card>
            <CardHeader color="primary">
              <Box
                display={"flex"}
                alignItems={"center"}
                justifyContent={"space-between"}
              >
                <h4 className={classes.cardTitleWhite}>Send WhatsApp</h4>
                <Box>
                  <Button color="primary" onClick={() => _getOrders()} >
                    Get Orders
                  </Button>
                  <Button color="primary" onClick={() => _postWhatsApp()} disabled={whatsappSent} >
                    Send WhatsApp
                  </Button>
                </Box>
              </Box>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <Autocomplete
                    id="party"
                    className={classes.formControl}
                    options={lab}
                    value={selectedLab}
                    onChange={(event, value) => {
                      setSelectedLab(value);
                      setOrders([]);
                      setSelectedRows([]);
                      setOrderLoaded(false);
                      setWhatsappSent(false);
                    }}
                    getOptionLabel={(option) => option?.labName || ""}
                    renderInput={(params) => (
                      <TextField {...params} label="Select Lab*" />
                    )}
                  />
                </GridItem>
              </GridContainer>

              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <Checkbox
                      style={{ color: "#512da8" }}
                      onChange={(e) => {
                        let c = [];
                        if (e.target.checked) {
                          orders.map((i) => {
                            c.push(i._id);
                          });
                        }
                        setSelectedRows(c);
                      }}
                      checked={selectedRows.length > 0 && orders.length === selectedRows.length}
                      inputProps={{ "aria-labelledby": -1 }}
                    />
                    {columns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={"center"}
                        style={{ minWidth: column.minWidth }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {orders.map((row, index) => (
                    <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                      <TableCell padding="checkbox">
                        <Checkbox
                          style={{ color: "#512da8" }}
                          onChange={() => {
                            let copy = _.clone(selectedRows);
                            if (_.includes(copy, row._id)) {
                              let index = _.indexOf(copy, row._id);
                              copy.splice(index, 1);
                            } else {
                              copy.push(row._id);
                            }
                            setSelectedRows(copy);
                          }}
                          checked={_.includes(selectedRows, row._id)}
                          inputProps={{ "aria-labelledby": row._id }}
                        />
                      </TableCell>
                      {columns.map((column) => {
                        if (column.id === "party") {
                          return (
                            <TableCell key={column.id} align={"center"}>
                              {row.party.accountName}
                            </TableCell>
                          );
                        }
                        if (column.id === "code") {
                          return (
                            <TableCell key={column.id} align={"center"}>
                              {row.code}
                            </TableCell>
                          );
                        }
                        if (column.id === "productName") {
                          return (
                            <TableCell key={column.id} align={"center"}>
                              {row.orderDetail.productName}
                            </TableCell>
                          );
                        }
                        if (column.id === "power") {
                          return (
                            <TableCell key={column.id} align={"center"}>
                              R - {row.orderDetail.rSph}{row.orderDetail.rCyl}/{row.orderDetail.rAxis}/{row.orderDetail.rAddition}
                              <br />
                              L - {row.orderDetail.lSph}{row.orderDetail.lCyl}/{row.orderDetail.lAxis}/{row.orderDetail.lAddition}
                            </TableCell>
                          );
                        }
                        if (column.id === "orderAmount") {
                          return (
                            <TableCell key={column.id} align={"center"}>
                              {row.price}
                            </TableCell>
                          );
                        }
                      })}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </Dialog>
  );
}